import { Button } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'
import { useModalToast, useToast } from 'components/misc/Toaster'
import {
    getSearchEngineErrorMessage,
    reindexProvider,
} from 'components/providers/searchEngine/searchEngineApi'
import { useState } from 'react'

interface Props {
    providerId: number
}

const ConfirmReindexProviderModal = NiceModal.create(({ providerId }: Props) => {
    const modal = useModal()
    const { addToast } = useToast()
    const { addModalToast } = useModalToast()
    const [isReindexing, setIsReindexing] = useState(false)

    function onConfirm() {
        setIsReindexing(true)
        reindexProvider(providerId)
            .then(() => {
                addToast({ msg: 'Provider reindexed in the search engine', green: true })
                modal.hide()
            })
            .catch((error: unknown) => {
                addModalToast({ msg: getSearchEngineErrorMessage(error), red: true })
                setIsReindexing(false)
            })
    }

    return (
        <BaseModal preventClose={isReindexing}>
            <BaseModalHeader>
                <h3 className="m-0">Reindex provider {providerId}</h3>
            </BaseModalHeader>
            <BaseModalMainContent>
                <p className="mt-0">
                    Rebuilds this provider&apos;s documents in the providers and subscriptions
                    indexes from the database, right away.
                </p>
                <p className="mb-0">
                    Documents of a disabled provider, deleted subscriptions or subscriptions that no
                    longer exist are removed from the search engine.
                </p>
            </BaseModalMainContent>
            <BaseModalFooter className="flex justify-between">
                <Button disabled={isReindexing} appearance="secondary" onClick={() => modal.hide()}>
                    Cancel
                </Button>
                <Button disabled={isReindexing} appearance="primary" onClick={onConfirm}>
                    Reindex
                </Button>
            </BaseModalFooter>
        </BaseModal>
    )
})

export default ConfirmReindexProviderModal
